<template>
  <div>
    <v-autocomplete
      class="mr-1"
      prepend-inner-icon="mdi-magnify"
      v-model="selected"
      solo-inverted
      hide-no-data
      hide-details
      clearable
      label="Search service ID and service name"
      :items="services"
      :item-text="labelText"
      :search-input.sync="keyword"
      item-value="radiusServiceId"
      return-object
      color="dark"
      @change="onRowSelected"
    ></v-autocomplete>
  </div>
</template>

<script>
import { debounce } from "vue-debounce";
export default {
  name: "SearchBar",
  data: () => ({
    selected: null,
    keyword: null,
  }),
  methods: {
    labelText(item) {
      return `${item.serviceId}: ${item.serviceName}`;
    },
    onRowSelected(val) {
      let vm = this;
      if (vm.selected) {
        // vm.setAvailableService(val);
        // vm.getService();
        // vm.getStatus();
        vm.$router.replace(`/service-details/${val.radiusServiceId}`);
      }
    },
  },
  watch: {
    keyword() {
      let vm = this;
      if (vm.keyword !== null)
        debounce((x) => {
          vm.getNbnServices({ search: x });
        }, 300)(vm.keyword);
    },
  },
};
</script>
